import { flowAsync } from '@gcc/nodash';
import { get, map } from 'lodash/fp';

import navigateToCart from '../navigateToCart';
import { copyConfiguration } from '../../api/designBuilder';
import { addConfigurationsToCart } from '../../api/autobahn';

export default flowAsync(
  map(item => copyConfiguration(
    get('itemProduct.configurationGuid')(item),
    get('label')(item),
  )),
  async promises => Promise.all(promises),
  addConfigurationsToCart,
  navigateToCart,
);
